import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/reports',
        name: 'reports.index',
        component: () => import('./pages/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/reports/:id',
        name: 'reports.show',
        component: () => import('./pages/Show.vue'),
        meta: {
            layout: 'app',
            navigation: {
                reports: { name: 'reports.index' },
            },
        },
        children: [
            {
                path: 'details',
                name: 'reports.show.details',
                component: () => import('./pages/reports/Details.vue'),
                meta: { layout: 'app' },
            },
            {
                path: 'selected-products',
                name: 'reports.show.selected-products',
                component: () => import('./pages/reports/SelectedProducts.vue'),
                meta: { layout: 'app' },
            },
            {
                path: 'risks',
                name: 'reports.show.risks',
                component: () => import('./pages/reports/ProductRisks.vue'),
                meta: { layout: 'app' },
            },
            {
                path: 'risk-analysis',
                name: 'reports.show.risk-analysis',
                component: () => import('./pages/reports/RiskAnalysis.vue'),
                meta: {
                    layout: 'app',
                },
            },
            {
                path: 'verification-report',
                name: 'reports.show.verification-report',
                component: () =>
                    import('./pages/reports/VerificationReport.vue'),
                meta: {
                    layout: 'app',
                },
            },
        ],
    },
    {
        path: '/reports/:id/todos',
        name: 'reports.todos.index',
        component: () => import('./pages/reports/todo/Index.vue'),
        meta: {
            layout: 'app',
        },
        children: [
            {
                path: ':todo',
                name: 'reports.todos.show',
                props: true,
                component: () => import('./pages/reports/todo/Show.vue'),
                meta: {
                    layout: 'app',
                },
            },
        ],
    },
] satisfies RouteRecordRaw[];
